import { Dispatch, SetStateAction } from "react";

export enum ProfileTabs {
  PROFILES = "profiles",
  KID_PROFILES = "kid-profiles",
  ADD_PROFILE = "add-profile",
  PIN = "pin",
  OPEN_PIN = "open-pin",
  IMAGE = "image",
  PROFILE_LANG = "profile-lang",
  CONTENT_LANG = "content-lang",
  MOVIES = "movies",
}

export interface GateProfilePagesProps {
  setTab: Dispatch<SetStateAction<ProfileTabs>>;
}
